import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomList } from 'src/components/CustomList';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  className: '',
};

export const BaseItemsList = ({ className, children }) => {
  const styles = useStyles();

  return <CustomList className={cx(styles.root, className)}>{children}</CustomList>;
};

BaseItemsList.displayName = 'BaseItemsList';
BaseItemsList.propTypes = propTypes;
BaseItemsList.defaultProps = defaultProps;
